import { AsYouType } from "libphonenumber-js";
import React, { useMemo } from "react";
import { ControllerFieldState } from "react-hook-form";
import TextFieldInput from "./TextFieldInput";

type PhoneFieldProps = {
  mRef?: React.RefObject<HTMLInputElement>;
  label?: string;
  minLength?: number;
  maxLength?: number;
  disabled?: boolean;
  field: any;
  fieldState: ControllerFieldState;
  className?: string;
  placeholder?: string;
};

const PhoneFieldInput = ({
  label = "Phone",
  minLength = 14,
  maxLength = 15,
  field,
  fieldState,
  className,
  placeholder
}: PhoneFieldProps) => {
  const phoneDisplayValue = useMemo(() => {
    const phoneFormatter = new AsYouType("US");
    const phone = phoneFormatter.input(field.value ? field.value.replace("+1", "") : field.value || "");
    return phone;
  }, [field.value]);
  return (
    <TextFieldInput
      data-testid="PhoneField"
      type="tel"
      minLength={minLength}
      maxLength={maxLength}
      label={label}
      placeholder={placeholder}
      className={className}
      field={{
        ...field,
        value: phoneDisplayValue,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          const phoneFormatter = new AsYouType("US");
          phoneFormatter.input(
            e.target.value.length === 4 && e.target.value.startsWith("(")
              ? e.target.value.substring(0, 3)
              : e.target.value
          );

          field.onChange(phoneFormatter.getNumber()?.number ?? phoneFormatter.getNationalNumber());
        }
      }}
      fieldState={fieldState}
    />
  );
};

export default PhoneFieldInput;
